import React from "react";
import PreviewPopoverReservationSegment from "./PreviewPopoverReservationSegment";
import PreviewPopoverReservation from "./PreviewPopoverReservation";
import PreviewPopoverCustomer from "./PreviewPopoverCustomer";
import PreviewPopoverFolio from "./PreviewPopoverFolio";
import PreviewPopoverHousekeepingLog from "./PreviewPopoverHousekeepingLog";
import PreviewPopoverServiceLog from "./PreviewPopoverServiceLog";
import PreviewPopoverProduct from "./PreviewPopoverProduct";
import PreviewPopoverFolioItem from "./PreviewPopoverFolioItem";
import PreviewPopoverGroupContract from "./PreviewPopoverGroupContract";
import PreviewPopoverIncidentalDeposit from "./PreviewPopoverIncidentalDeposit";
import PreviewPopoverNotes from "./PreviewPopoverNotes";
import PreviewPopoverRoomTypePrice from "./PreviewPopoverRoomTypePrice";
import PreviewPopoverSeason from "./PreviewPopoverSeason";
import PreviewPopoverAutomaticPriceRule from "./PreviewPopoverAutomaticPriceRule";
import PreviewPopoverDailyRate from "./PreviewPopoverDailyRate";
import PreviewPopoverBarChartToolTip from "../ChartPresenter/ToolTipDisplays/BarChartToolTip";
import PreviewPopoverOrder from "./PreviewPopoverOrder";

class PreviewPopover extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div>
        { this.props.model_type === "reservation_segment" ? <PreviewPopoverReservationSegment {...this.props} /> : null }
        { this.props.model_type === "reservation" ? <PreviewPopoverReservation {...this.props} /> : null }
        { this.props.model_type === "customer" ? <PreviewPopoverCustomer {...this.props} /> : null }
        { this.props.model_type === "folio" ? <PreviewPopoverFolio {...this.props} /> : null }
        { this.props.model_type === "housekeeping_log" ? <PreviewPopoverHousekeepingLog {...this.props} /> : null }
        { this.props.model_type === "service_log" ? <PreviewPopoverServiceLog {...this.props} /> : null }
        { this.props.model_type === "product" ? <PreviewPopoverProduct {...this.props} /> : null }
        { this.props.model_type === "folio_item" ? <PreviewPopoverFolioItem {...this.props} /> : null }
        { this.props.model_type === "group_contract" ? <PreviewPopoverGroupContract {...this.props} /> : null }
        { this.props.model_type === "incidental_deposit" ? <PreviewPopoverIncidentalDeposit {...this.props} /> : null }
        { this.props.model_type === "note" ? <PreviewPopoverNotes {...this.props} /> : null }
        { this.props.model_type === "room_type_price" ? <PreviewPopoverRoomTypePrice {...this.props} /> : null }
        { this.props.model_type === "season" ? <PreviewPopoverSeason {...this.props} /> : null}
        { this.props.model_type === "automatic_price_rule" ? <PreviewPopoverAutomaticPriceRule {...this.props} /> : null}
        { this.props.model_type === "daily_rate" ? <PreviewPopoverDailyRate {...this.props} /> : null}
        {/* {this.props.model_type === "report_detail" ? <PreviewPopoverReportDetails {...this.props} /> : null} */}
        {this.props.model_type === "chart_tool_tip" && this.props.chartType && this.props.chartType === 'horizontal_bar_chart' ? <PreviewPopoverBarChartToolTip {...this.props} /> : null}
        {this.props.model_type === "order" ? <PreviewPopoverOrder {...this.props} /> : null}
      </div>
    )
  }
}

export default PreviewPopover